import React, { useEffect, useRef, useState, useMemo } from "react"
import * as THREE from "three"
import {useSphere } from "@react-three/cannon"
import { useThree, useFrame } from "@react-three/fiber"
import useStore from "../StateStore/store"
import usePlayerControls from "../Custom Hooks/usePlayerControls"

const SPEED = 50;
const direction = new THREE.Vector3()
const frontVector = new THREE.Vector3()
const sideVector = new THREE.Vector3()
const euler = new THREE.Euler(0, 0, 0, "YXZ")
let a = 0

function lerp( start , end, amt ) {
	return ( 1 - amt ) * start  + amt * end;
}

const FPSNew = (props) => {
    
  const propogation = useStore(state => state.propogateToStall)

  const [ref, api] = useSphere(() => ({ 
    mass: 10, 
    type: "Dynamic",   
    position : [0, 0, 0], 
    rotation: [0, 0, 0],
    ...props 
  }))
  const blind = useRef()

  const teleportation = useStore(state => state.playerTeleport)
  const setTeleport = useStore(state => state.playerTeleport.setTeleport)
  let controllerState = useStore(state => state.touchController)

  const {dummyVector, dummyVector2} = useMemo(() =>{
      return{
        dummyVector : new THREE.Vector3(),
        dummyVector2 : new THREE.Vector3()
      }
    } , [])

    const teleport = () => {
      if(teleportation.position){
        dummyVector.set(teleportation.position.x, 0, teleportation.position.z)
        dummyVector2.lerp(dummyVector, 0.03)
        
        api.position.set(dummyVector2.x, 0, dummyVector2.z)
        
        if(camera.position.distanceTo(teleportation.position) <= 6){
          setTeleport(false)
        }
      }
    }

    
    const propogate = React.useCallback(() => {
        blind.current.material.visible = true
        a+=0.03
        blind.current.material.opacity = lerp(blind.current.material.opacity, 1.3, 0.025)

        if(blind.current.material.opacity > 0.99){
          const r = propogation.position.z > 0 ? 1 : 0
          api.position.set(propogation.position.x, 0, propogation.position.z)
            if(propogation.rotation){
              camera.rotation.set(0, Math.PI * r+propogation.rotation, 0)
            }else{
              camera.rotation.set(0, Math.PI * r, 0)
            }
          
        }
        
    }, [])

    let {forward, backward, left, right, up, down} = usePlayerControls()

    const { camera } = useThree()
 
    useEffect(() => {camera.rotation.set(0, 0, 0)}, [])
    const velocity = useRef([0, 0, 0])

    useEffect(() => void api.velocity.subscribe((v) => (velocity.current = v)), [])
    useFrame(() => {
        blind.current.position.set(ref.current.position.x, 5, ref.current.position.z )
        // blind.current.position.copy(camera.position)
        if(teleportation.teleportState === true){
          teleport()
        }else{
          dummyVector2.set(camera.position.x, 0, camera.position.z )
        }

        if(propogation.propogateState === true){
          propogate()
          ref.current.getWorldPosition(camera.position);
          camera.position.y = 5
          // camera.position.set(ref.current.position.x, 5, ref.current.position.z)
        }else{
          blind.current.material.opacity = lerp(blind.current.material.opacity, -0.4, 0.01)
          if(blind.current.material.opacity < -0.1){
            blind.current.material.visible = false
          }
          if(propogation.exitButton === false){
            if(controllerState.buttonsActive === true){
              forward = controllerState.movementState.forward
              backward = controllerState.movementState.backward
              left = controllerState.movementState.left
              right = controllerState.movementState.right
            }
            
            ref.current.getWorldPosition(camera.position);
            camera.position.y = 5
            // camera.rotation.y = Math.PI
            // camera.position.set(ref.current.position.x, 5, ref.current.position.z)
            frontVector.set(0, 0, Number(backward) - Number(forward))
            euler.setFromQuaternion( camera.quaternion );
            euler.y += (Number(left)-Number(right)) * 0.01
            euler.x += (Number(up)-Number(down)) *0.01
            if(forward === true || backward === true ){
              euler.x = lerp(euler.x, 0, 0.03)
              euler.z = lerp(euler.z, 0, 0.03)
            }
            camera.quaternion.setFromEuler( euler );
            sideVector.set(0, 0, 0)
            direction.subVectors(frontVector, sideVector).normalize().multiplyScalar(SPEED).applyEuler(camera.rotation)
            
            api.velocity.set(direction.x, velocity.current[1], direction.z)
          }
        } 

        
    })

    return (
      <>
        
        <mesh ref={ref}>
        </mesh>
        <mesh ref={blind} >
            <boxBufferGeometry args={[1, 1, 1]} />
            <meshBasicMaterial color={"black"} side={THREE.DoubleSide} transparent />
        </mesh>
        
      </>
    )
    
}

export default FPSNew
